import styled, { css } from 'styled-components/macro';

import { large, medium } from 'styles/breakpoints';
import { room } from 'styles/layout';

export const Container = styled.div`
  ${room}
`;

export const windowStyles = css`
  height: 108px;
  position: absolute;
  right: 20%;
  top: 44px;
  width: 62px;

  ${medium`
    height: 116px;
    right: 71px;
    top: 31px;
    width: 68px;
  `}

  ${large`
    right: 107px;
    top: 59px;
  `}
`;

export const endTableStyles = css`
  bottom: 100px;
  height: 122px;
  left: 41%;
  position: absolute;
  width: 52px;

  ${medium`
    height: 132px;
    left: 143px;
    width: 57px;
  `}

  ${large`
    left: 191px;
  `}
`;

export const doorStyles = css`
  bottom: 100px;
  height: 170px;
  left: 11.4%;
  position: absolute;
  width: 84px;

  ${medium`
    height: 186px;
    left: 41px;
    width: 92px;
  `}

  ${large`
    left: 86px;
  `}
`;

export const Light = styled.div`
  height: 70px;
  left: 50%;
  margin-left: -30px;
  position: absolute;
  top: -1px;
  width: 59px;

  ${medium`
    height: 75px;
    margin-left: -32px;
    top: -12px;
    width: 63px;
  `}

  ${large`
    top: 0;
  `}
`;

export const Switch = styled.div`
  height: 23px;
  left: 4%;
  position: absolute;
  top: 77px;
  width: 13px;

  ${medium`
    height: 25px;
    left: 13px;
    top: 64px;
    width: 15px;
  `}

  ${large`
    left: 44px;
    top: 92px;
  `}
`;

export const Outlet = styled.div`
  bottom: 130px;
  height: 23px;
  left: 4%;
  position: absolute;
  width: 13px;

  ${medium`
    bottom: 134px;
    height: 25px;
    left: 13px;
    width: 15px;
  `}

  ${large`
    left: 44px;
  `}
`;

export const Thermostat = styled.div`
  height: 26px;
  position: absolute;
  right: 3.7%;
  top: 74px;
  width: 39px;

  ${medium`
    height: 28px;
    right: 16px;
    top: 64px;
    width: 43px;
  `}

  ${large`
    right: 45px;
    top: 92px;
  `}
`;

export const Vent = styled.div`
  bottom: 110px;
  height: 21px;
  position: absolute;
  right: 3.7%;
  width: 49px;

  ${medium`
    height: 23px;
    right: 11px;
    width: 54px;
  `}

  ${large`
    right: 40px;
  `}
`;
